
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { InvestmentOpportunity } from "@/types/investment";

interface OriginalContractSectionProps {
  formData: InvestmentOpportunity;
  onInputChange: (field: keyof InvestmentOpportunity, value: any) => void;
  onNumericChange: (field: keyof InvestmentOpportunity, value: string) => void;
}

const OriginalContractSection = ({ formData, onInputChange, onNumericChange }: OriginalContractSectionProps) => {
  return (
    <div className="border-t pt-6">
      <h3 className="text-lg font-semibold mb-4">Original Contract Terms</h3>
      <div className="grid md:grid-cols-2 gap-4">
        <div>
          <Label htmlFor="original_sales_price">Original Sales Price</Label>
          <Input
            id="original_sales_price"
            type="number"
            step="0.01"
            value={formData.original_sales_price === 0 ? '' : formData.original_sales_price || ''}
            onChange={(e) => onNumericChange('original_sales_price', e.target.value)}
            placeholder="Enter original sales price"
          />
        </div>
        <div>
          <Label htmlFor="original_down_payment">Original Down Payment</Label>
          <Input
            id="original_down_payment"
            type="number"
            step="0.01"
            value={formData.original_down_payment === 0 ? '' : formData.original_down_payment || ''}
            onChange={(e) => onNumericChange('original_down_payment', e.target.value)}
            placeholder="Enter down payment amount"
          />
        </div>
        <div>
          <Label htmlFor="original_interest_rate">Original Interest Rate (%)</Label>
          <Input
            id="original_interest_rate"
            type="number"
            step="0.01"
            value={formData.original_interest_rate === 0 ? '' : formData.original_interest_rate || ''}
            onChange={(e) => onNumericChange('original_interest_rate', e.target.value)}
            placeholder="Enter interest rate (e.g., 5.5)"
          />
        </div>
        <div>
          <Label htmlFor="original_monthly_payment">Original Monthly Payment</Label>
          <Input
            id="original_monthly_payment"
            type="number"
            step="0.01"
            value={formData.original_monthly_payment === 0 ? '' : formData.original_monthly_payment || ''}
            onChange={(e) => onNumericChange('original_monthly_payment', e.target.value)}
            placeholder="Enter monthly payment amount"
          />
        </div>
        <div>
          <Label htmlFor="original_balloon_payment">Original Balloon Payment</Label>
          <Input
            id="original_balloon_payment"
            type="number"
            step="0.01"
            value={formData.original_balloon_payment === 0 ? '' : formData.original_balloon_payment || ''}
            onChange={(e) => onNumericChange('original_balloon_payment', e.target.value)}
            placeholder="Enter balloon payment amount (if any)"
          />
        </div>
      </div>
    </div>
  );
};

export default OriginalContractSection;
